import { WORLD_SEED } from "../content/scale";

export type PedestrianState =
  | "PLAN_ROUTE"
  | "WALK"
  | "WAIT_SIGNAL"
  | "CROSS"
  | "QUEUE_PORTAL"
  | "ENTER_BUILDING"
  | "QUEUE_PLATFORM"
  | "RIDE_TRANSIT"
  | "DESPAWN";

function fnv1a(value: string): number {
  let hash = 0x811c9dc5;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}

export class CitySimulation {
  readonly capacity: number;
  readonly ids: Uint32Array;
  readonly xMm: Int32Array;
  readonly zMm: Int32Array;
  readonly previousXMm: Int32Array;
  readonly previousZMm: Int32Array;
  readonly speedMmPerSecond: Int16Array;
  readonly state: Uint8Array;
  activeCount = 0;
  proxyCount = 0;
  abstractCount = 0;

  constructor(capacity = 180) {
    this.capacity = capacity;
    this.ids = new Uint32Array(capacity);
    this.xMm = new Int32Array(capacity);
    this.zMm = new Int32Array(capacity);
    this.previousXMm = new Int32Array(capacity);
    this.previousZMm = new Int32Array(capacity);
    this.speedMmPerSecond = new Int16Array(capacity);
    this.state = new Uint8Array(capacity);
  }

  reconcile(serviceDate: string, localHour: number, cap: number): void {
    const demand =
      localHour < 5
        ? 0.25
        : localHour < 7
          ? 0.55
          : localHour < 10
            ? 1
            : localHour < 16
              ? 0.75
              : localHour < 19
                ? 1
                : 0.7;
    this.activeCount = Math.min(this.capacity, Math.round(cap * demand));
    this.proxyCount = this.activeCount * 3;
    this.abstractCount = this.activeCount * 18;
    for (let index = 0; index < this.activeCount; index += 1) {
      const seed = fnv1a(`${WORLD_SEED}|${serviceDate}|pedestrian|${index}`);
      this.ids[index] = seed;
      this.xMm[index] = ((seed & 0xffff) % 180_000) - 90_000;
      this.zMm[index] = (((seed >>> 16) & 0xffff) % 180_000) - 90_000;
      this.speedMmPerSecond[index] = 1200 + (seed % 601);
      this.state[index] = 1;
    }
  }

  fixedUpdate(stepSeconds: number): void {
    for (let index = 0; index < this.activeCount; index += 1) {
      this.previousXMm[index] = this.xMm[index] ?? 0;
      this.previousZMm[index] = this.zMm[index] ?? 0;
      const speed = this.speedMmPerSecond[index] ?? 0;
      const direction = (this.ids[index] ?? 0) & 1 ? 1 : -1;
      let next = (this.xMm[index] ?? 0) + Math.round(speed * stepSeconds * direction);
      if (Math.abs(next) > 90_000) next = -next;
      this.xMm[index] = next;
    }
  }
}
